export default __webpack_public_path__ + "static/media/dark6.58e49093.png";